import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import Breadcrumb from 'components/Breadcrumb'
import Button from 'components/Button'

import { USERS_URL, CLIENTS_URL } from 'constants'

import { statusChanged } from 'components/RequestStatus/actions'

import AccountData from './components/AccountData'
import AdditionalData from './components/AdditionalData'


import './index.scss'


export class NewClient extends BaseComponent {

  constructor(props) {
    super(props)
    this.state = {
      buttonProps: {
        disabled: true
      },
      errors: {
        first_name: [],
        last_name: [],
        email: [],
        confirm_email: []
      }
    }

    this._bind('_handleSubmit', '_createClient', '_cancelNewClient')
  }

  componentWillReceiveProps(nextProps) {
    const userData = nextProps.user.dataOk
    const stateId = nextProps.state.id !== null ? true : false
    const locationId = nextProps.location.id != null ? true : false

    this.setState({
      buttonProps: {
        disabled: !(userData && stateId && locationId)
      }
    })
  }

  _handleSubmit(e) {
    e.preventDefault()
    this.props.updateRequestStatus('progress', 'Creando usuario...')
    request(USERS_URL, {
      method: 'POST',
      body: {
        ...this.props.user.formData
      }
    })
      .then((res) => {
        this.props.updateRequestStatus(res.status, res.message)
        this._createClient(res.user.uuid)
      })
      .catch(({response}) => {
        const errors = !!response.fields ? {...response.fields} : {}
        this.props.updateRequestStatus(response.status, response.message)
        this.setState({
          errors: {...errors}
        })
      })
  }

  _createClient(userId) {
    this.props.updateRequestStatus('progress', 'Creando cliente...')
    request(CLIENTS_URL, {
      method: 'POST',
      body: {
        user: userId,
        city: this.props.location.id
      }
    })
      .then((res) => {
        this.props.updateRequestStatus(res.status, res.message)
        this.context.router.history.replace(`/clientes/${res.client.user}/`)
      })
      .catch(({response}) => {
        const errors = !!response.fields ? {...response.fields} : {}
        this.props.updateRequestStatus(response.status, response.message)
        this.setState({
          errors: {...errors}
        })
      })
  }

  _cancelNewClient() {
    this.props.updateRequestStatus('progress', 'Cancelando la creación de cliente')
    this.context.router.history.replace('/clientes')
    this.props.updateRequestStatus('ok', 'Se canceló la creación de cliente')
  }

  render() {
    const breadcrumbKeys = {
      displayValues: { client_name: 'Pedrito', },
      pathValues: { id: 3 }
    }

    return (
      <div id="NewClient">
        <Breadcrumb levels={this.props.breadcrumb} keys={breadcrumbKeys}/>
        <form onSubmit={this._handleSubmit}>
          <h3 className="section-title  cl-achromatic-c-color">Agregar nuevo cliente</h3>
          <div className="d-flex dashboard-container justify-content-between align-items-start">
            <AccountData errors={this.state.errors}/>
            <AdditionalData />
          </div>
          <div className="controls">
            <Button type="submit"
                    className="button"
                    size="big"
                    buttonType="primary" {...this.state.buttonProps}>Crear nuevo cliente</Button>
          </div>
        </form>
      </div>
    )
  }
}


NewClient.contextTypes = {
  router: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
  return {
    user: state.newClient.get('user'),
    state: state.newClient.get('state'),
    location: state.newClient.get('location')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(NewClient)



// WEBPACK FOOTER //
// ./src/scenes/NewClient/index.js